import { Component, OnInit } from '@angular/core';
import { ReinsurancePostRiskService } from '../../../services/reinsurance-post-risk.service';
import { ActivatedRoute } from '@angular/router';
import { ViewNegativeMarketSlipComponent } from '../../dashboard/components/view-negative-market-slip/view-negative-market-slip.component';

@Component({
  selector: 'app-verify-slip-number',
  imports: [ViewNegativeMarketSlipComponent],
  templateUrl: './verify-slip-number.component.html',
  styleUrl: './verify-slip-number.component.scss',
})
export class VerifySlipNumberComponent implements OnInit {
  slipNumber: string = '';
  slipData: any;
  riskData: any;

  constructor(
    private riskService: ReinsurancePostRiskService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    console.log('VerifySlipNumberComponent initialized');
    const slipNumber = this.route.snapshot.queryParamMap.get('slipNumber')!;

    if (slipNumber) {
      console.log('Slip Number:', slipNumber);
      this.riskService.getPublicRiskReport({ slipNumber: slipNumber }, (result: any) => {
        console.log('Offer data:', result);
        this.riskData = result.data.risk;
        this.slipData = result.data.offers;
        // Handle the result as needed
      });

      // this.riskService.getRiskBySlipNumberOpen(this.slipNumber, (result: any) => {
      //   console.log('Risk data:', result);
      //   this.riskData = result;
      //   // Handle the result as needed
      // });
    } else {
      console.error('No slip number provided');
    }
    // Initialization logic can go here
  }
}
